export const findConfigFiles = async (node, result = []) => {
    if (node?.type === "file" && node?.category === "config") {
        result.push(node.path);
    }else{
        for(let subdir in node.contents){
            await findConfigFiles(node.contents[subdir],result)
        }
    }
    return result;
}

export const findAndAddToObject = async (node, name, path) => {
    if(node.path === path){
        node.contents = {
            ...node.contents,
            "ADD_FOLDER": {
                "name": "ADD_FOLDER",
                "path": path + "/ADD_FOLDER",
                "type": "directory",
                "contents": {}
            }
        }
        return node;
    }else{
        for(let subdir in node.contents){
            const folderStructure = await findAndAddToObject(node.contents[subdir],name,path)
            if(Object.keys(folderStructure).length > 0){
                node.contents[subdir] = folderStructure;
                return node;
            }
        }
    }
    return {}
}

export const findAndRemoveObject = async (node, folderName, folderPath) => {
    if (node.contents) {
        if (node.contents[folderName] && node.contents[folderName].path === folderPath) {
            // Found the target folder, add the new object to its contents

            delete node.contents[folderName];
            return node;
        } else {
            // Traverse through other subdirectories
            for (let subdir in node.contents) {
                const folderStructure = await findAndRemoveObject(node.contents[subdir], folderName, folderPath);
                
                if (Object.keys(folderStructure).length > 0) {
                    node.contents[subdir] = folderStructure;
                    return node;
                }
            }
        }
    }
    return {};
}

export const findAndAddFolder = async (node, folderName, folderPath) => {
    if (node.contents) {
        if (node.contents["ADD_FOLDER"] && node.contents["ADD_FOLDER"].path === folderPath) {
            // Found the target folder, add the new object to its contents

            delete node.contents["ADD_FOLDER"];
            const newNode = {
                ...node,
                contents: {
                    ...node.contents,
                    [folderName]: {
                        "name": folderName,
                        "path": folderPath === '/ADD_FOLDER' ? folderPath.replace("/ADD_FOLDER", folderName) : folderPath.replace("ADD_FOLDER", folderName),
                        "type": "directory",
                        "contents": {}
                    }
                }
                
            }
            return newNode;
        } else {
            // Traverse through other subdirectories
            for (let subdir in node.contents) {
                const folderStructure = await findAndAddFolder(node.contents[subdir], folderName, folderPath);
                
                if (Object.keys(folderStructure).length > 0) {
                    node.contents[subdir] = folderStructure;
                    return node;
                }
            }
        }
    }
    return {};
}
